import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft, ExternalLink } from "lucide-react";
import "@/community.css";
import OverviewTab from "./admin-community/OverviewTab";
import BulletinTab from "./admin-community/BulletinTab";
import EventsTab from "./admin-community/EventsTab";
import PriveTab from "./admin-community/PriveTab";
import GalleryTab from "./admin-community/GalleryTab";
import { ApplicationsTab, MembersTab } from "./admin-community/PeopleTabs";
import { EmailsTab, ContentTab, ActivityTab } from "./admin-community/MiscTabs";

const TABS = [
  ["overview", "Overview", OverviewTab], ["bulletin", "Bulletin", BulletinTab], ["events", "Events & RSVPs", EventsTab],
  ["applications", "Applications", ApplicationsTab], ["members", "Members", MembersTab], ["prive", "Privé", PriveTab],
  ["gallery", "Gallery", GalleryTab], ["emails", "Emails", EmailsTab], ["content", "Page content", ContentTab], ["activity", "Activity", ActivityTab],
];

export default function AdminCommunity() {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "overview";
  const [ok, setOk] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("jenova_admin_token")) navigate("/admin/login");
    else setOk(true);
  }, [navigate]);
  if (!ok) return null;
  const goTo = (t) => setParams({ tab: t });
  const Active = (TABS.find((t) => t[0] === tab) || TABS[0])[2];

  return (
    <div className="jc-root min-h-screen bg-[#F5EFE6]" data-testid="admin-community">
      <header className="bg-[#FBF8F3] border-b border-[#E8DCCB]">
        <div className="max-w-[1500px] mx-auto px-5 md:px-10 pt-6 pb-0">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div>
              <Link to="/admin" className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.2em] text-[#7A6A62] hover:text-[#2B2522]" data-testid="admin-community-back">
                <ArrowLeft className="w-3.5 h-3.5" /> Store admin
              </Link>
              <h1 className="jc-display text-4xl md:text-5xl mt-3">Founder <em className="italic text-[#A8865A]">Dashboard</em></h1>
              <p className="jc-eyebrow mt-2">The Jenova Girls Experience</p>
            </div>
            <Link to="/experience" target="_blank" className="inline-flex items-center gap-1.5 text-xs border border-[#E8DCCB] rounded-full px-4 py-2 hover:border-[#2B2522]" data-testid="admin-community-view-site">
              View community <ExternalLink className="w-3.5 h-3.5" />
            </Link>
          </div>
          <nav className="jc-scroll-x mt-6 flex gap-6 overflow-x-auto" data-testid="admin-community-tabs">
            {TABS.map(([id, label]) => (
              <button key={id} onClick={() => goTo(id)} data-testid={`admin-tab-${id}`}
                className={`shrink-0 pb-3 text-[11px] uppercase tracking-[0.18em] border-b-2 transition-colors ${tab === id ? "border-[#C9A97A] text-[#2B2522]" : "border-transparent text-[#7A6A62] hover:text-[#2B2522]"}`}>
                {label}
              </button>
            ))}
          </nav>
        </div>
      </header>
      <main className="max-w-[1500px] mx-auto px-5 md:px-10 py-8">
        <Active goTo={goTo} />
      </main>
    </div>
  );
}
